import React from "react";
import { LocalServiceTemplate } from "@/components/local/LocalServiceTemplate";
import { localServiceData } from "@/data/localServiceData";

const ZonnepanelenWestervoort = () => {
  return <LocalServiceTemplate data={localServiceData['zonnepanelen-westervoort']} />;
};

export default ZonnepanelenWestervoort;